import { render, staticRenderFns } from "./UserCommittedData.vue?vue&type=template&id=41d8bdc2&"
import script from "./UserCommittedData.vue?vue&type=script&lang=ts&"
export * from "./UserCommittedData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports